import {COLORS, WorkflowStatusType} from "../../../workflowStatus/constants";

export const PDF_OPEN_TYPE_COLOR_MAP_BY_COLOR_NAME = {
    [COLORS.PINK]: '#dd326e',
    [COLORS.ORANGE]: '#d77606',
    [COLORS.YELLOW]: '#d99400',
    [COLORS.LIGHT_GREEN]: '#6fb100',
    [COLORS.DARK_GREEN]: '#0ea95e',
    [COLORS.AQUAMARINE]: '#00b2c1',
    [COLORS.BLUE]: '#0066de',
    [COLORS.VIOLET]: '#4f3bc5',
    [COLORS.LIGHT_GRAY]: '#8585ab',
    [COLORS.DARK_GRAY]: '#2c5d86'
}

export const PDF_COMPLETED_TYPE_COLOR_MAP_BY_COLOR_NAME = {
    [COLORS.PINK]: '#cb4e7a',
    [COLORS.ORANGE]: '#ed8710',
    [COLORS.YELLOW]: '#e8a70d',
    [COLORS.LIGHT_GREEN]: '#79c428',
    [COLORS.DARK_GREEN]: '#2eb473',
    [COLORS.AQUAMARINE]: '#1bbabf',
    [COLORS.BLUE]: '#4d95ee',
    [COLORS.VIOLET]: '#8465d7',
    [COLORS.LIGHT_GRAY]: '#9f9fbd',
    [COLORS.DARK_GRAY]: '#778b9c'
}

export const PDF_ICON_MAP_BY_TYPE = {
    [WorkflowStatusType.COMPLETED]: "completedTask",
    [WorkflowStatusType.OPEN]: "openTask"
}


// WEBPACK FOOTER //
// ./web/js/user/viewtt/pdf/constants.js